/** Why a request to the share server didn't work: what it answered, or that it couldn't be reached (status 0). */
export class ShareError extends Error {
    constructor(
        readonly status: number,
        message: string,
    ) {
        super(message);
    }
}
